import { closeSheet, showToast } from '@/state/ui';
import { snoozeSchedule, resetScheduleInterval } from '@/lib/mutations';
import { Icon } from '@/components/Icon';
import type { BoardEntry } from '@/state/board';

const OPTIONS = [5, 15, 30];

export function SnoozeSheet({ entry }: { entry: BoardEntry }) {
  const snooze = async (mins: number) => {
    closeSheet();
    await snoozeSchedule(entry.schedule.id, mins);
    showToast({ kind: 'info', message: `${entry.animal.name} snoozed ${mins} min` });
  };

  const custom = async () => {
    const v = prompt('Snooze for how many minutes?', '45');
    const mins = v ? parseInt(v, 10) : NaN;
    if (!Number.isFinite(mins) || mins <= 0) return;
    await snooze(mins);
  };

  const reset = async () => {
    closeSheet();
    await resetScheduleInterval(entry.schedule.id);
    showToast({ kind: 'info', message: `${entry.animal.name} — interval restarted from now` });
  };

  return (
    <div>
      <div class="snooze-grid">
        {OPTIONS.map((m) => (
          <button key={m} class="snooze-opt" onClick={() => snooze(m)}>
            {m}m<span>snooze</span>
          </button>
        ))}
      </div>
      <button class="snooze-opt" style={{ width: '100%', height: '48px', flexDirection: 'row', gap: '8px' }} onClick={custom}>
        <Icon name="clock" size={16} /> Custom…
      </button>
      {entry.schedule.stype === 'interval' && (
        <button class="snooze-reset" onClick={reset}>
          <Icon name="refresh" size={20} />
          <span class="snooze-reset__text">
            <span class="snooze-reset__title">Reset interval</span>
            <br />
            <span class="snooze-reset__sub">
              Restart the every-{entry.schedule.interval_minutes}-min clock from right now
            </span>
          </span>
        </button>
      )}
    </div>
  );
}
